let nextMountId = 0;

// Temporary development diagnostics. Deliberately exclude URLs, query values,
// headers, errors and payloads: those can contain credentials/customer data.
const fields = [
  "requestId", "lane", "page", "generation", "reason", "source",
  "scope", "changedFields", "effectGeneration", "setupCount",
];

export function createProductionRequestDiagnostics({
  enabled = process.env.NODE_ENV === "development",
  write = (event) => console.debug("[production:requests]", event),
} = {}) {
  const mountId = `production-mount-${++nextMountId}`;
  const identities = new Map();
  const trace = (event, details = {}) => {
    if (!enabled) return;
    const safe = { event, mountId };
    fields.forEach((field) => {
      if (["string", "number", "boolean"].includes(typeof details[field])) {
        safe[field] = details[field];
      }
    });
    write(safe);
  };
  return {
    trace,
    identity(scope, values) {
      const previous = identities.get(scope);
      const changedFields = Object.keys(values).filter((key) =>
        !previous || previous.values[key] !== values[key]
      );
      const generation = (previous?.generation || 0) + (changedFields.length ? 1 : 0);
      identities.set(scope, { values, generation });
      trace("identity", { scope, generation, changedFields: changedFields.join(","),
        reason: !previous ? "initial" : changedFields.length ? "identity-change" : "same-identity-effect-setup" });
      return generation;
    },
  };
}
